import { render } from "./CarouselWidget.vue?vue&type=template&id=2050298d&scoped=true"
import script from "./CarouselWidget.vue?vue&type=script&lang=js"
export * from "./CarouselWidget.vue?vue&type=script&lang=js"

import "./CarouselWidget.vue?vue&type=style&index=0&id=2050298d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2050298d"]])

export default __exports__